import React from 'react';
import {LauncherComponentBase} from '../../base-components/launcher-component-base';
import {createStyles, Theme, withStyles} from "@material-ui/core/styles";
import {WithStyles} from '@material-ui/core'
import {observer} from 'mobx-react';
import Popper from '@material-ui/core/Popper';
import Paper from '@material-ui/core/Paper';
import {ISearchResultItem} from '../../../services/search/search-result/search-result-item.interface';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableRow from '@material-ui/core/TableRow';


const styles = (theme: Theme) => createStyles({
    paper: {
        marginTop: 20,
        minWidth: 350,
        backgroundColor: theme.palette.background.paper,
    },
    grow: {
        flexGrow: 1
    },
    table: {
        minWidth: 350,
    },
    searchResultHeader: {
        marginTop: theme.spacing(1)
    }
});

export interface LauncherSearchResultComponentProps extends WithStyles<typeof styles> {
    searchBoxElementRef: any;
    popperId: string;
}

export const LauncherSearchResultComponent = withStyles(styles)(
    observer(
        class extends LauncherComponentBase<LauncherSearchResultComponentProps> {

            private _renderOneSearchItem(item: ISearchResultItem) {
                return (
                  <TableRow key={item.key} hover={true}>
                      <TableCell>
                          {item.render()}
                      </TableCell>
                  </TableRow>
                );
            }

            private _renderSearchResult() {
                if(this.services.search.searchResult.length === 0) {
                    return (
                        <TableRow>
                            <TableCell>
                                {this.services.search.noMatchMessage}
                            </TableCell>
                        </TableRow>
                    );

                }

                return this.services.search.searchResult.slice(0,10).map(item => this._renderOneSearchItem(item));
            }

            render() {
                if (!this.services.search.isSearchInProgress) {
                    return null;
                }

                return (
                    <Popper id={this.props.popperId}
                            disablePortal={false}
                            open={this.services.search.isSearchInProgress}
                            anchorEl={this.props.searchBoxElementRef.current}
                            placement='bottom-start'
                            modifiers={{
                                flip: {
                                    enabled: true
                                },
                                preventOverflow: {
                                    enabled: true,
                                    boundariesElement: 'window',
                                }}}>


                        <Paper className={this.props.classes.paper}>
                            <TableContainer component={Paper}>
                                <Table className={this.props.classes.table} size='small'>
                                    <TableBody>
                                        {this._renderSearchResult()}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                        </Paper>
                    </Popper>

                )
            }
        }
    )
);

